<button
  #element
  [attr.id]="buttonId()"
  [attr.aria-label]="label()"
  [type]="type()"
  [class]="buttonClass()"
  [disabled]="disabled()"
  (click)="clicked.emit($event)"
  (blur)="handleBlur($event)"
  (focus)="handleFocus($event)"
  (mouseenter)="mouseEntered.emit($event)"
  (mouseleave)="mouseLeft.emit($event)"
  [ngStyle]="buttonStyle()"
>
  <div [ngClass]="contentClass()">
    <ng-content />
  </div>
</button>
